import { Aurelia, autoinject } from 'aurelia-framework';

import { HttpClient } from 'aurelia-http-client';
import { I18N } from 'aurelia-i18n';
import { Router } from 'aurelia-router';
import {  AuthInterceptor } from 'Config';

@autoinject
export class BaseAdapter {
    protected httpClient: HttpClient = null;
    protected i18n : I18N = null;
    public authInterceptor: any = null;

    constructor(httpClient: HttpClient, i18n: I18N, authInterceptor: AuthInterceptor) {   
        this.httpClient = httpClient;
        this.i18n = i18n;

        this.authInterceptor = authInterceptor;
        this.httpClient.configure(x => {
            x.withInterceptor(this.authInterceptor);
        });        
    }
}